/**
 * Universal contact form success message handler
 * Works with ANY contact form on ANY page
 */
(function () {
  'use strict';

  async function handleContactFormSuccess() {
    const urlParams = new URLSearchParams(window.location.search);
    const contactPosted = urlParams.get('contact_posted');

    if (contactPosted !== 'true') return;

    // Find any contact form on the page
    const contactForm = document.querySelector('.contact-form');
    if (!contactForm) return;

    // Skip if contact form is inside contact-group-toggle (it has its own handler)
    if (contactForm.closest('contact-group-toggle')) return;

    // Check if success message already exists (rendered by Liquid)
    let successMessage = contactForm.querySelector('.contact-form__success');

    if (!successMessage) {
      // Create success message element
      successMessage = document.createElement('div');
      successMessage.className = 'contact-form__success';
      successMessage.setAttribute('tabindex', '-1');

      // Fetch and add checkmark icon
      try {
        const iconResponse = await fetch(window.Shopify.routes.root + 'cdn/shop/t/2/assets/icon-tick-circle.svg');
        const iconSvg = await iconResponse.text();
        const iconWrapper = document.createElement('div');
        iconWrapper.innerHTML = iconSvg;
        successMessage.appendChild(iconWrapper.firstChild);
      } catch (error) {
        console.error('Failed to load checkmark icon:', error);
      }

      // Add success text
      const text = document.createTextNode("Thanks for contacting us. We'll get back to you as soon as possible.");
      successMessage.appendChild(text);

      // Find the form and submit button
      const form = contactForm.querySelector('form');
      const submitButton = form?.querySelector('button[type="submit"]');

      if (form && submitButton) {
        // Insert success message before the submit button
        submitButton.parentNode.insertBefore(successMessage, submitButton);

        // Hide the submit button
        submitButton.style.display = 'none';
      }
    } else {
      // Success message already exists, just hide the submit button
      const form = contactForm.querySelector('form');
      const submitButton = form?.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.style.display = 'none';
      }
    }

    // Scroll to success message
    setTimeout(() => {
      successMessage?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      successMessage?.focus();
    }, 300);

    // Clean up URL (remove query parameter)
    const url = new URL(window.location);
    url.searchParams.delete('contact_posted');
    window.history.replaceState({}, '', url);
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleContactFormSuccess);
  } else {
    handleContactFormSuccess();
  }
})();
